import React, { memo } from 'react';
import { AssetImage } from '../../../assets/Asset';

const ItopWrapper = memo(({ children }) => {
  if (window.innerWidth >= 1000)
    return (
      <div
        style={{
          height: '100vh',
          backgroundColor: '#5EAFD8',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundImage: `url(${AssetImage.iTopLoginBackground})`,
        }}>
        <div
          style={{
            width: 400,
            height: 300,
            borderRadius: 150,
            background: '#5EAFD8',
            color: '#fff !important',
          }}>
          <div style={{ paddingTop: '30%', marginLeft: '15%' }}>{children}</div>
        </div>
        <div
          style={{
            position: 'absolute',
            top: '7%',
            right: '10%',
            width: 400,
            height: 300,
            lineHeight: '25px',
            color: 'rgb(48, 156, 210)',
          }}>
          <h4 style={{ fontWeight: 'bold' }}>PHẦN MỀM UPSELL HIỆU QUẢ ĐA KÊNH</h4>
          • Nâng cao hiệu quả và thời gian chăm sóc khách hàng
          <br />
          • Kịch bản tự động trả lời trên tất cả các kênh hoàn toàn miễn phí
          <br />
          • Quản lý đa kênh đồng thời trên: Facebook cá nhân, Fanpage, Zalo OA, Website, Shopee,
          Sendo, Email, Zalo
          <br />
          • Tối đa hiệu suất từng nhân viên - Tiết kiệm chi phí nhân sự
          <br />
          • Theo dõi hoạt động bán hàng & hiệu suất từng nhân viên
          <br />
          • Tạo đơn hàng, xử lý đơn hàng và lựa chọn dịch vụ ship dễ dàng
          <br />
          • Quản lý dễ dàng trên thiết bị di động (Android & iOS)
          <br />
          <img src={AssetImage.iTopLoginLap} style={{ width: '100%', marginTop: 30 }} alt="img" />
        </div>
      </div>
    );

  return (
    <div
      className="flex-center-col"
      style={{ height: '100vh', backgroundColor: '#5EAFD8', color: '#fff' }}>
      {children}
    </div>
  );
});

export default ItopWrapper;
